import type { FC } from "react";

import style from "./styles/Form.module.scss";

import { TooltipController } from "@/ui-modules/core/overlays/components/OverlayControllers.js";

export interface FormInputWidgetProps {
  //horizontalLayout?: boolean;
  children: React.ReactNode;
  tooltip?: string;
}

const FormInputWidget: FC<FormInputWidgetProps> = (props) => {
  //const classes = clsx(style.form_group, { [style.horizontal_form_group]: props.horizontalLayout });

  return (
    <TooltipController content={props.tooltip}>
      {(tooltipTriggerProps) => (
        <div
          className={style.input_widget}
          data-testid={"form-input"}
          onPointerEnter={tooltipTriggerProps.onPointerEnter}
          onPointerLeave={tooltipTriggerProps.onPointerLeave}
          ref={tooltipTriggerProps.ref}
        >
          {props.children}
        </div>
      )}
    </TooltipController>
  );
};

export { FormInputWidget };
